module.exports = __webpack_public_path__ + "static/media/gameDetailMain.68b6eb3f.jpg";